import {
  LocationIdentifier,
  ReactionByID,
  ShippingData,
  ShippingFormVariant,
  StoredBillingData,
  VisitorUser,
} from './types'

enum StorageKeys {
  BILLING_DATA = 'billingData',
  CART_ID = 'cartID',
  CART_PAYMENT_DATA = 'cartPaymentData',
  SHIPPING_DATA = 'shippingData',
  OBITUARY_MEMORY_REACTIONS = 'obituaryMemoryReactions',
  OBITUARY_MEMORY_COMMENT_REACTIONS = 'obituaryMemoryCommentReactions',
  VISITOR_USER = 'visitor_user',
}

export const NULL_VISITOR_USER = {
  email: '',
  location: '',
  name: '',
}

export const NULL_SHIPPING_DATA: ShippingData = {
  address_line_1: '',
  address_line_2: '',
  city: '',
  delivery_date: '',
  name: '',
  personal_message: '',
  phone: '',
  shippingFormVariant: ShippingFormVariant.LOCATION_1,
  state: '',
  zip: '',
}

export const NULL_BILLING_DATA: StoredBillingData = {
  month: '',
  year: '',
  first_name: '',
  last_name: '',
  address_line_1: '',
  address_line_2: '',
  city: '',
  state: '',
  zip: '',
  phone: '',
  email: '',
}

export const storage = {
  getCartID: (): string => sessionStorage.getItem(StorageKeys.CART_ID) || '',
  getShippingData: (
    defaultLocationIdentifier: LocationIdentifier = LocationIdentifier.LOCATION1,
  ): ShippingData => {
    const unparsedShippingData = sessionStorage.getItem(StorageKeys.SHIPPING_DATA)

    if (unparsedShippingData) {
      return JSON.parse(unparsedShippingData)
    }

    return defaultLocationIdentifier === LocationIdentifier.LOCATION2
      ? { ...NULL_SHIPPING_DATA, shippingFormVariant: ShippingFormVariant.LOCATION_2 }
      : NULL_SHIPPING_DATA
  },
  getStoredBillingData: (): StoredBillingData => {
    const unparsedBillingData = sessionStorage.getItem(StorageKeys.BILLING_DATA)

    if (unparsedBillingData) {
      return JSON.parse(unparsedBillingData)
    }

    return NULL_BILLING_DATA
  },
  getVisitorUser: (): VisitorUser => {
    const unparsedVisitorUser = localStorage.getItem(StorageKeys.VISITOR_USER)

    if (unparsedVisitorUser) {
      return JSON.parse(unparsedVisitorUser)
    }

    return NULL_VISITOR_USER
  },
  setCartID: (cartID: string): void => sessionStorage.setItem(StorageKeys.CART_ID, cartID),
  setShippingData: (shippingData: ShippingData): void =>
    sessionStorage.setItem(StorageKeys.SHIPPING_DATA, JSON.stringify(shippingData)),
  setStoredBillingData: (billingData: StoredBillingData): void =>
    sessionStorage.setItem(StorageKeys.BILLING_DATA, JSON.stringify(billingData)),
  setVisitorUser: (user: VisitorUser): void => {
    localStorage.setItem(StorageKeys.VISITOR_USER, JSON.stringify(user))
  },
  addObituaryMemoryReaction: (memoryID: number, reactionID: number) => {
    const existingReactions = storage.getObituaryMemoryReactions()

    localStorage.setItem(
      StorageKeys.OBITUARY_MEMORY_REACTIONS,
      JSON.stringify({ ...existingReactions, [memoryID]: reactionID }),
    )
  },
  getObituaryMemoryReactions: (): ReactionByID => {
    return JSON.parse(localStorage.getItem(StorageKeys.OBITUARY_MEMORY_REACTIONS)) || {}
  },
  removeCartID: (): void => sessionStorage.removeItem(StorageKeys.CART_ID),
  removeShippingData: (): void => sessionStorage.removeItem(StorageKeys.SHIPPING_DATA),
  removeStoredBillingData: (): void => sessionStorage.removeItem(StorageKeys.BILLING_DATA),
  removeObituaryMemoryReaction: (memoryID: number) => {
    const existingReactions = storage.getObituaryMemoryReactions()
    delete existingReactions[String(memoryID)]

    localStorage.setItem(StorageKeys.OBITUARY_MEMORY_REACTIONS, JSON.stringify(existingReactions))
  },
}
